import styled from "@emotion/styled";
import {Styles} from "@tpd-web-common-libs/nodejs-library";


export const LoginContainer = styled.div`
    display: flex;

    .container-ar-button {
        width: 100%;
        height: 100%;
    }

    .tpd_top_icon_third {
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        text-decoration: none !important;
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
        display: none;

        &:focus,
        &:hover {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            text-decoration: none;
        }

        .tpd_reserved_area_icon {
            font-size: 35px;
            position: absolute;
            top: 5px;
        }
    }

    ${Styles.BreakpointsUtils.desktopOnly(`
        .tpd_top_icon_third {
            display: initial;
        }
    `)}
`;

export const LoginDropdown = styled.div`
    &.login-home {
        cursor: default;
        display: none;
    }

    //Mobile - Default
    z-index: 100;
    width: 320px;
    background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
    position: absolute;
    top: 55px;
    right: 0;

    .tpd_form {
        padding: 25px 17px 27px 0;
    }

    .tpd_ipt {
        margin-bottom: 9px;
    }

    .login-dropdown_title, .login-dropdown_privacy-text {
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$medium"]};
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
    }
  
    

    .login-dropdown_privacy-text {
        font-size: 14px;
        line-height: 1;
        margin-bottom: 7px;
        a {
          color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        }  
    }

    .login-dropdown_btn_wrapper {
        
        .login-dropdown_btn {
            margin-bottom: 9px;
            height: 45px;
            border: none;
            border-radius: 0;
        }

        .login-dropdown_input {
            height: 45px;
            border: none;
            border-radius: 0;
            cursor: pointer;

            .tpd_search_icon {
                color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
                font-size: 28px;
            }
            
            .us-input-wrapper-errors,
            .us-input-wrapper-valid {
                border-color: inherit !important;
            }
            .us-input-errors-wrapper {
                display: none !important;
            }
        }
        
        .expiredPassword {
            font-size: small;
            text-align: justify;
            line-height: 1.6;
            text-transform: uppercase;
            margin-bottom: 5px;
        }
        
        .login-dropdown_error_message {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$error_red"]};
            font-size: 12px;
            text-transform: uppercase;
            margin-bottom: 10px;
            
            &_2{
                margin-top: 10px;
                text-transform: uppercase;
            }
        }
        
        .us-button {
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
            outline: none;
        }
    }

    .login-dropdown_btn {
        .text-contact {
            margin: 20px 0;
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$error_red"]};
            font-size: 16px;
            text-transform: none;
        }
    }

    /*.tpd_ipt_ricordami {
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        font-size: 16px;
        margin-bottom: 12px;
        border: none;
        border-radius: 0;

        .bk_047_ricordami {
            float: left;
            width: 20px;
            height: 20px;
            background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};

            label {
                width: 20px;
                height: 20px;
                cursor: pointer;
                position: absolute;
                top: 4px;
                left: 6px;
                border-radius: 0;
                margin-bottom: 0;

                &:after {
                    content: "";
                    width: 9px;
                    height: 5px;
                    position: absolute;
                    top: 3px;
                    left: 4px;
                    border: 3px solid ${Styles.GlobalStyleVariables.widgetVariablesStyle["$body_color"]};
                    border-top: none;
                    border-right: none;
                    opacity: 0;
                    transform: rotate(-45deg);
                }

                &:hover:after {
                    opacity: 0.5;
                }
            }

            input[type="checkbox"] {
                margin: 4px;
                visibility: hidden;

                &:checked + label:after {
                    opacity: 1;
                }
            }
        }
    }*/

    .tpd_ipt_recupera_pwd {
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
        font-size: 14px;
        text-align: left;
        margin-top: -5px;
        margin-bottom: 15px;

        a {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
            padding: 0;
            text-decoration: none;

            &:hover {
                color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
                opacity: 0.7;
                text-decoration: underline;
            }
        }
    }

    .login-dropdown_btn_accedi {
        height: 24px;
        background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        padding: 5px 20px;
        line-height: 16px;
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$medium"]};
        border: none;
        outline: transparent;
        display: inline-block;
        position: relative;
        margin: 0;
        font-size: 16px;
        width: 210px;

        &:active,
        &:hover {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$main_color"]};
        }

        &:hover {
            background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$medium-light-blue"]};
            opacity: 0.7;
        }
        
        &:focus {
            outline: none;
            outline-offset: inherit;
        }

        &:disabled {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            background-color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$grey"]};
            cursor: not-allowed;
        }
    }

    .tpd_description {
        margin-top: 3px;
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        margin-bottom: 25px;
        font-size: 16px;
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};

        &_btn {
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            text-decoration: underline;
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
            font-size: 16px;
            cursor: pointer;

            &:hover {
                color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
                opacity: 0.7;
            }
        }
    }

    .tpd_accedi_con {
        margin-bottom: 14px;
        font-size: 16px;
        font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
    }

    .tpd_social {
        color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
        min-height: 46px;

        .tpd_iconWrapper .tpd_icon {
            padding: 2px;
            margin-right: 38px;
            font-size: 40px;
            display: inline;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};

            &:focus,
            &:hover {
                text-decoration: none;
                opacity: 0.8;
            }
        }
    }

    .login-dropdown_content {
        padding: 20px 0;
        text-transform: initial;
        line-height: 30px;
    }

    .login-dropdown_privacy {
        padding-left: 8px;
        margin-top: 5px;
        * {
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$medium"]};
            font-size: 10px;
        }
        
        a {
            text-decoration: none;
            padding: 5px 0;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            &:hover {
                opacity: 0.7 !important;
            }
        }
    }


    //Tablet
    ${Styles.BreakpointsUtils.tabletAndDesktopOnly(`
        width: 540px;
        
        .tpd_form {
            padding: 20px 30px 20px 0;
        }
        
        .login-dropdown_btn_wrapper {
            .login-dropdown_input {
                &:hover {    
                    -webkit-transition: all 0.25s ease-out 0s;
                    -moz-transition: all 0.25s ease-out 0s;
                    -ms-transition: all 0.25s ease-out 0s;
                    -o-transition: all 0.25s ease-out 0s;
                    transition: all 0.25s ease-out 0s;
                }
            }
        }
        
        .tpd_ipt_recupera_pwd {
            a:hover {    
                -webkit-transition: all 0.25s ease-out 0s;
                -moz-transition: all 0.25s ease-out 0s;
                -ms-transition: all 0.25s ease-out 0s;
                -o-transition: all 0.25s ease-out 0s;
                transition: all 0.25s ease-out 0s;
            }
        } 
        
        .login-dropdown_btn_accedi {
            height: 36px;
            -webkit-transition: all 0.25s ease-out 0s;
            -moz-transition: all 0.25s ease-out 0s;
            -ms-transition: all 0.25s ease-out 0s;
            -o-transition: all 0.25s ease-out 0s;
            transition: all 0.25s ease-out 0s;
        }
        
        .tpd_description {
            &_btn {
                &:hover {    
                    -webkit-transition: all 0.25s ease-out 0s;
                    -moz-transition: all 0.25s ease-out 0s;
                    -ms-transition: all 0.25s ease-out 0s;
                    -o-transition: all 0.25s ease-out 0s;
                    transition: all 0.25s ease-out 0s;
                }
            }
        }
    `)};

    //Desktop
    ${Styles.BreakpointsUtils.desktopOnly(`
        &.login-home {
            display: initial;
        }
        
        top: 51px;
        width: 610px;
        
        .tpd_form {
            padding: 30px 50px 25px 0;
        }
        
        .login-dropdown_title, {
            text-transform: none;
            line-height: normal;
        }
    `)};
`;

export const UserLogged = styled.div`
    &.user-logger-wrapper {
        height: 50px;
        width: 100%;
    }

    .tpd-login-header-user-logged-container {
        display: flex;
        flex-direction: row;
        line-height: normal;
        height: 100%;
        align-items: center;
        justify-content: space-evenly;

        .tpd-login-header-name {
            display: none;
            width: 80%;
            border-right: 1px solid ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            text-decoration: none;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            &:focus,
            &:hover {
                text-decoration: none;
            }
        }
        .tpd-login-header-name-esci {
            display: none;
            flex-direction: column;
            align-items: center;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            text-decoration: none;
            &:focus,
            &:hover {
                color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
                text-decoration: none;
            }
            i {
                font-size: 30px;
                text-decoration: none;
            }
            span {
                font-size: 10px;
                text-transform: none;
                text-decoration: none;
            }
        }
        
        .tablet-logout {
            cursor: pointer;
            display: none;
            align-items: center;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            
            .tablet-esci-logout {
                font-family: Unipol;
                font-size: 16px;
                margin-right: 10px;
            }
            .icon-Esci {
                font-size: 40px;
            }

            ${Styles.BreakpointsUtils.mobileAndTabletOnly(`
                display: flex;
                position: relative;
                top: 5px;
            `)};
        }

        .tpd_top_icon_third_greating_type {
            text-transform: none;
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$normal"]};
        }
        
        .tpd_top_icon_third_greating_name {
            font-family: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$bold"]};
        }
        
        ${Styles.BreakpointsUtils.desktopOnly(`
            .tpd-login-header-name {
                display: initial;
            }

            .tpd-login-header-name-esci {
                display: flex;
                margin-top: -6px;
                .icon-Esci {
                    font-size: 40px;
                    span {
                        margin-top: -5px;
                    }
                }
            }
        `)};        
    }
`;

export const UserNotification = styled.div`
    &.tpd_top_icon_second {
        visibility: hidden;
        position: relative;
        
        a {
            text-decoration: none;
            &:hover {
                text-decoration: none;
            }

            .icon-Notifiche {
                font-size: 50px;
                &:before {
                    color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
                }
            }
        }
        
        .notifications-counter {
            font-size: 12px;
            position: absolute;
            width: 20px;
            height: 20px;
            line-height: 1;
            top: 5px;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            border: 1px solid red;
            background-color: red;
            padding: 3px;
            border-radius: 40px;
            z-index: 1;
            
            &.plus-99 {
                font-size: 9px;
                padding-left: 0.5px;
                padding-top: 5px;
            }

            @media (min-width: 1280px) and (max-width: 1500px) {
                right: 8px;
            }

            @media (min-width: 1501px) {
                right: 22px;
            }
        }

        ${Styles.BreakpointsUtils.desktopOnly(`
            visibility: visible;
            left: -7px;
            padding: 3px;
            padding-top: 0;
            border-right: 1px solid ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            text-decoration: none;
            color: ${Styles.GlobalStyleVariables.widgetVariablesStyle["$white"]};
            height: 50px;
        `)};
    }
`;

export const LoginLoadingContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100;
`;
